const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class TestimonialsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.timeout = ''
    this.delay = 10000

    this.currentIndex = 1

    this.carousel = this.setupCarousel()

    this.setTimeout = this.setTimeout.bind(this)
    this.setNextSlide = this.setNextSlide.bind(this)

    this.setTimeout()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.setActiveIndex = this.setActiveIndex.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 5000,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 3.3,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 4.3,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 5,
              spacing: 20,
            },
          },
        },
        slideChanged: (instance) => {
          const activeIndex = instance.track.details.rel + 1

          this.setActiveIndex(activeIndex.toString())
        },
        detailsChanged: (instance) => {
          this.els.trigger.elements.forEach((triggerEl, index) => {
            const matchingSlide = instance.track.details.slides[index]

            const slidePortion = matchingSlide.portion

            const blurLimit = window.BAO.MediaBreakpoints.isMd ? 5 : 2
            const blurAmount = blurLimit - blurLimit * slidePortion

            triggerEl.style.filter = `blur(${blurAmount}px)`
          })
        },
      },
      [setInitialised()],
    )
  }

  handleTrigger (event) {
    const clickedTrigger = event.target.closest(this.els?.trigger?.selector)

    this.setActiveIndex(clickedTrigger.dataset.index)
  }

  setTimeout () {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(this.setNextSlide, this.delay)
  }

  setNextSlide () {
    const maxSlides = this.els.trigger.elements.length
    const newIndex =
      this.currentIndex + 1 > maxSlides ? 1 : this.currentIndex + 1

    this.setActiveIndex(newIndex)
  }

  setActiveIndex (index) {
    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.index === index.toString(),
      )
    })

    this.els.message?.elements.forEach((messageEl) => {
      messageEl.setAttribute(
        'aria-hidden',
        messageEl.dataset.index !== index.toString(),
      )
    })

    this.currentIndex = parseInt(index)

    this.setTimeout()
  }
}

if (!customElements.get('testimonials-carousel')) {
  customElements.define('testimonials-carousel', TestimonialsCarousel)
}
